import { useState } from 'react';

export default function useBrowserStorage(key, defaultValue = null, storage = window.localStorage) {
  const [value, setValue] = useState(() => {
    const stored = storage.getItem(key);
    return stored != null ? JSON.parse(stored) : defaultValue;
  });

  const setItem = value => {
    setValue(value);
    storage.setItem(key, JSON.stringify(value));
  };

  const removeItem = () => {
    storage.removeItem(key);
    setValue(defaultValue);
  };

  return [value, setItem, removeItem];
}
